import bindScroll from '../helpers/bindScroll';
import urlHelper from '../helpers/UrlHelper';
import carouselWrapperTpl from '../templates/carousels/wrapper.tpl';
import portraitCarousel from '../components/portraitCarousel';
import landscapeCarousel from '../components/landscapeCarousel';
import DMAStorageService from '../services/DMAStorageService';
import prominentCarousel from './prominentCarousel';
import contentHighlightCarousel from '../components/highlight/carousel/ContentHighlightCarousel';

import {
    MODEL_CHARACTER_CAROUSEL,
    MODEL_HUB,
    MODEL_SHOW_MOVIE_HYBRID,
    MODEL_TRENDING,
    MODEL_TOP_SHOWS,
    MODEL_TOP_STORIES,
    MODEL_MULTICHANNEL,
    MODEL_CHANNEL,
    MODEL_VIDEO,
    MODEL_PROMINENT_CAROUSEL,
} from '../shared/constants';

export default function getRecursiveConfigCarousels(resp) {
    try {
        let objs = [];
        let _regionPrefix = CBS.Registry.region.prefix;
        let userState = CBS.Registry.user_auth ? 'rg' : 'an';
        let belowTheFoldContainer = document.querySelector('.bottom-components');
        let DMAStorage = new DMAStorageService();

        let collectionConfig = resp.reverse();

        function createWrapperCarousel(data, options) {
            let wrapper = $(
                carouselWrapperTpl({
                    recoId: data.recoId,
                    displayId: data.displayId,
                    title: data.title,
                    carouselId: data.carouselId ? data.carouselId : '',
                    carouselPresentationStyle: data.carouselPresentationStyle ?? '',
                    position: data.position ? data.position : '',
                    id: data.title.replace(/\'+/g, '').replace(/\s+/g, '-').toLowerCase(),
                    model: data.model,
                    rankModel: data.rankModel,
                    customClass: data.model === MODEL_CHARACTER_CAROUSEL ? 'kids-carousel' : '',
                }),
            );

            let carouselElement = wrapper.find('.js-video-carousel');

            let obj = {
                wrapper: carouselElement,
                init: function () {
                    wrapper.on('init', () => {
                        carouselElement.removeClass('hidden');
                    });

                    wrapper.on('setPosition', () => {
                        wrapper.ellipsify();
                    });

                    if (data.orientation === 'portrait') {
                        if (
                            CBS.Registry.Features.content_highlight_web_search &&
                            options?.contentHighlight === true
                        ) {
                            contentHighlightCarousel({
                                parentContainer: carouselElement[0],
                                options: options,
                                orientation: data.orientation,
                            });
                        } else {
                            portraitCarousel({
                                parentContainer: carouselElement,
                                options: options,
                            });
                        }
                    } else {
                        if (options.isChannel) {
                            wrapper.on('videoDataLoad', (e, result) => {
                                result?.data?.forEach((item) => {
                                    if (!item.isLive) {
                                        item.scheduleBadge = true;
                                        const time = new Date(parseInt(item.startTimestamp));
                                        item.scheduleBadgeText = formatEventTime(time);
                                    }
                                });
                            });

                            onNowLandscapeCarousel({
                                parentContainer: carouselElement,
                                options: options,
                            });
                        } else {
                            if (
                                CBS.Registry.Features.content_highlight_web_search &&
                                options?.contentHighlight === true
                            ) {
                                contentHighlightCarousel({
                                    parentContainer: carouselElement[0],
                                    options: options,
                                    orientation: data.orientation,
                                });
                            } else {
                                landscapeCarousel({
                                    parentContainer: carouselElement,
                                    options: options,
                                });
                            }
                        }
                    }
                },
            };

            belowTheFoldContainer.insertAdjacentElement('beforeend', wrapper.get(0));
            return obj;
        }

        function recursiveConfigurationCarousels(collections) {
            if (collections.length > 0) {
                let carouselData = collections.pop();
                let token = carouselData.token;

                if (
                    carouselData.model === MODEL_HUB ||
                    carouselData.model === MODEL_SHOW_MOVIE_HYBRID ||
                    carouselData.model === MODEL_TRENDING ||
                    carouselData.model === MODEL_TOP_SHOWS ||
                    carouselData.model === MODEL_TOP_STORIES ||
                    carouselData.model === MODEL_CHARACTER_CAROUSEL
                ) {
                    let baseEndpoint =
                        _regionPrefix +
                        '/carousels/collections/configItems/' +
                        userState +
                        '/' +
                        encodeURIComponent(token) +
                        '/offset/{offset}/limit/{limit}/';
                    baseEndpoint = urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);
                    let options = {
                        endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                        params: {
                            slug: carouselData.slug,
                            sectionId: carouselData.sectionId,
                        },
                        contentHighlight: carouselData.isContentHighlightEnabled ?? false,
                    };

                    objs.push(createWrapperCarousel(carouselData, options));
                    recursiveConfigurationCarousels(collections);
                } else if (
                    carouselData.model === MODEL_VIDEO ||
                    carouselData.model === MODEL_CHANNEL ||
                    carouselData.model === MODEL_MULTICHANNEL
                ) {
                    let endpoint =
                        _regionPrefix +
                        '/carousels/collections/configItems/' +
                        userState +
                        '/' +
                        encodeURIComponent(token) +
                        '/offset/0/limit/0/';

                    $.ajax({
                        url: endpoint,
                        dataType: 'json',
                        type: 'GET',
                        cache: false,
                        headers: {
                            'Cache-Control': 'no-cache',
                            Pragma: 'no-cache',
                            Expires: '0',
                        },
                    }).done(function (resp) {
                        if (resp === null) {
                            recursiveConfigurationCarousels(collections);
                            return;
                        }

                        if (carouselData.model === MODEL_VIDEO) {
                            resp = JSON.parse(resp);

                            if (!resp.success || resp.result.data.length === 0) {
                                recursiveConfigurationCarousels(collections);
                                return;
                            }

                            let group = resp.result.data;
                            group.forEach((item) => {
                                let title =
                                    typeof item.title !== 'undefined'
                                        ? item.title
                                              .replace(/\'+/g, '')
                                              .replace(/\s+/g, '-')
                                              .toLowerCase()
                                        : '';

                                let data = {
                                    title: title,
                                    id: item.title
                                        .replace(/\'+/g, '')
                                        .replace(/\s+/g, '-')
                                        .toLowerCase(),
                                };

                                let baseEndpoint =
                                    CBS.Registry.region.prefix +
                                    '/shows/{slug}/xhr/sectionId/{sectionId}/offset/{offset}/limit/{limit}/xs/0/';

                                let options = {
                                    endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                                    params: {
                                        slug: 'hubs',
                                        sectionId: item.id,
                                    },
                                    contentHighlight:
                                        carouselData.isContentHighlightEnabled ?? false,
                                };
                                objs.push(createWrapperCarousel(data, options));
                            });
                        }

                        if (carouselData.model === MODEL_CHANNEL) {
                            if (!resp.success || resp.result.data.length === 0) {
                                recursiveConfigurationCarousels(collections);
                                return;
                            }

                            (async () => {
                                let [dma, stationId] = DMAStorage.getDMAStationIdStringOnNow();
                                let dmaParams =
                                    dma != null && stationId != null
                                        ? `&dma=${dma}&stationId=${stationId}`
                                        : '&dma=&stationId=';
                                let channel = resp.result.data;
                                let title = carouselData.title
                                    .replace(/\'+/g, '')
                                    .replace(/\s+/g, '-');
                                let data = {
                                    title: title,
                                    id: title.toLowerCase(),
                                };
                                let localTimeZone =
                                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                                let baseEndpoint =
                                    CBS.Registry.region.prefix +
                                    `/carousels/collections/{slug}/xhr/schedule-events/offset/{offset}/limit/{limit}/?timeZone=${localTimeZone}${dmaParams}`;

                                /**
                                 * Very specific update to Showtime hub/collection Carousels: append bundleStatus for proper caching
                                 * TODO: Generalize as necessary where bundleStatus will change a user's carousel response
                                 * in terms of status/lock
                                 */
                                if (carouselData.slug == 'showtime') {
                                    baseEndpoint =
                                        urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);
                                }
                                let options = {
                                    endPoint: baseEndpoint,
                                    params: {
                                        slug: channel.slug,
                                    },
                                    isChannel: true,
                                    contentHighlight:
                                        carouselData.isContentHighlightEnabled ?? false,
                                };
                                objs.push(createWrapperCarousel(data, options));
                            })();
                        }

                        if (carouselData.model === MODEL_MULTICHANNEL) {
                            let title = carouselData.title.replace(/\'+/g, '').replace(/\s+/g, '-');
                            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                            let data = {
                                title: title,
                                id: title.toLowerCase(),
                            };

                            let baseEndpoint =
                                CBS.Registry.region.prefix +
                                `/carousels/collections/{slug}/xhr/multichannel-events/offset/{offset}/limit/{limit}/?timezone=${localTimeZone}&title=${title}`;

                            let options = {
                                endPoint: baseEndpoint,
                                params: {
                                    slug: carouselData.channelSlug,
                                },
                                isChannel: true,
                                contentHighlight: carouselData.isContentHighlightEnabled ?? false,
                            };
                            objs.push(createWrapperCarousel(data, options));
                        }

                        recursiveConfigurationCarousels(collections);
                    });
                } else if (carouselData.model === MODEL_PROMINENT_CAROUSEL) {
                    let baseEndpoint =
                        _regionPrefix +
                        '/carousels/collections/configItems/' +
                        userState +
                        '/' +
                        encodeURIComponent(token) +
                        '/offset/{offset}/limit/{limit}/';
                    baseEndpoint = urlHelper.appendBundleStatusAndPackageCode(baseEndpoint);

                    let options = {
                        endPoint: baseEndpoint, //----- THIS MUST BE ROUTE AND RETURN ENDPOINT DATA
                        params: {
                            slug: carouselData.slug,
                            sectionId: carouselData.sectionId,
                        },
                        contentHighlight: carouselData.isContentHighlightEnabled ?? false,
                    };

                    carouselData.options = options;
                    carouselData.customClass = 'prominent-carousel-wrapper';

                    let wrapper = $(carouselWrapperTpl(carouselData));
                    belowTheFoldContainer.insertAdjacentElement('beforeend', wrapper.get(0));
                    objs.push(new prominentCarousel(wrapper, carouselData));

                    recursiveConfigurationCarousels(collections);
                } else {
                    recursiveConfigurationCarousels(collections);
                }
            } else {
                new bindScroll(objs);
                objs = [];
            }
        }

        recursiveConfigurationCarousels(collectionConfig);
    } catch (e) {
        console.error('carousel group failed to load', e);
    }
}
